export const getLabel = ({
  values,
  fallback,
}: {
  values: Array<string | null | undefined>;
  fallback?: string | null;
}) => {
  const label = values.filter(Boolean).join(' ').trim();

  return label || (fallback ?? 'N/A');
};
